export interface IK2ViewCustomerData {
  addressId: string;
  currentServiceTechnology: string;
  orderingSystem: string;
  product: IK2ViewProduct[];
  qualificationItem: IK2ViewQualificationItem[];
  serviceQualification: IK2ViewServiceQualification[];
}

interface IK2ViewServiceQualification {
  isDPORequired: string;
  technologyType: string;
}

interface IK2ViewQualificationItem {
  typeCode: string;
  typeOfService: string;
}

export interface IK2ViewProduct {
  typeCode: string;
  typeOfService: string;
  orderingSystem: string;
  productTerm: IK2ViewProductTerm;
}

export interface IK2ViewProductTerm {
  name: string;
  description: string;
  duration: {
    amount: number;
    units: string;
  };
  validFor: {
    startDateTime: Date;
    endDateTime: Date;
  };
}

export class K2ViewCustomerData implements IK2ViewCustomerData {
  orderingSystem: string;
  addressId: string;
  currentServiceTechnology: string;
  product: IK2ViewProduct[];
  qualificationItem: IK2ViewQualificationItem[];
  serviceQualification: IK2ViewServiceQualification[];

  constructor(k2viewCustomerData: IK2ViewCustomerData) {
    this.orderingSystem = k2viewCustomerData.orderingSystem;
    this.addressId = k2viewCustomerData.addressId;
    this.currentServiceTechnology = k2viewCustomerData.currentServiceTechnology;
    this.product = k2viewCustomerData.product;
    this.qualificationItem = k2viewCustomerData.qualificationItem;
    this.serviceQualification = k2viewCustomerData.serviceQualification;
  }
}
